import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.tagmortgages.co.uk";
const SITE_NAME = "TAG Mortgages";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;
const DEFAULT_IMAGE_ALT = "TAG Mortgages logo";

const SEO = ({ title, description, path = "/" }) => {
  const pageTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const canonicalPath = path.startsWith("/") ? path : `/${path}`;
  const canonicalUrl =
    canonicalPath === "/" ? `${SITE_URL}/` : `${SITE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:image:alt" content={DEFAULT_IMAGE_ALT} />
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
      <meta name="twitter:image:alt" content={DEFAULT_IMAGE_ALT} />
    </Helmet>
  );
};

export default SEO;
